import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/workspace/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/workspace/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["Breadcrumbs"] */ "/workspace/src/components/breadcrumbs/breadcrumbs.tsx");
